export const tableColumns = [
    {
        name: "kodeDocument",
        label: "Kode Dokumen",
    },
    {
        name: "mainDealer",
        label: "Main Dealer",
    },
    {
        name: "expiredDate",
        label: "Tanggal Berlaku",
    },
    {
        name: "cabangBerlaku",
        label: "Cabang Berlaku",
    },
];

export const formGroup = {
    kodeCabang: { value: "", mandatory: true },
    kodeDocument: { value: "", mandatory: false },
    mainDealer: { value: "", mandatory: true },
    expiredDate: { value: "", mandatory: true },
    cabangBerlaku: { value: [] },
    detail: {
      value: [
        {
          kodeVariant: { value: "", mandatory: true },
          onTheRoad: { value: 0, mandatory: true },
          offTheRoad: { value: 0, mandatory: true },
        },
      ],
      mandatory: true,
    },
  };
  